import { useContext, createContext } from 'react';

const AccordionContext = /*#__PURE__*/createContext(null);
function useAccordionContext() {
  const context = useContext(AccordionContext);
  if (!context) {
    throw new Error('use-accordion hook was called outside of AccordionProvider context');
  }
  return context;
}

export { AccordionContext, useAccordionContext };
